module.exports = __webpack_public_path__ + "static/media/value-proposition-great-company@2x.b56f6be8.png";